<template>
  <div id="app"> 
    <Header  v-if="showHeader=true "></Header>
    <div class="clearfix"></div>
    <Banner :PageTitle="$route.name"/>
    <!-- <nav class="navbar navbar-expand navbar-dark bg-dark">
      <a href class="navbar-brand" @click.prevent>Brand</a>
      <div class="navbar-nav mr-auto">
        <li class="nav-item">
          <router-link to="/home" class="nav-link">
            <font-awesome-icon icon="home" />Home
          </router-link>
        </li>
        <li v-if="showAdminBoard" class="nav-item">
          <router-link to="/Employee" class="nav-link">Employee</router-link>
        </li>
        <li v-if="showModeratorBoard" class="nav-item">
          <router-link to="/Admission" class="nav-link">Admission</router-link>
        </li>
        <li class="nav-item">
          <router-link v-if="currentUser" to="/Applicant" class="nav-link">Applicant</router-link>
        </li>
      </div>

      <div v-if="!currentUser" class="navbar-nav ml-auto">
        <li class="nav-item">
          <router-link to="/register" class="nav-link">
            <font-awesome-icon icon="user-plus" />Sign Up
          </router-link>
        </li>
        <li class="nav-item">
          <router-link to="/login" class="nav-link">
            <font-awesome-icon icon="sign-in-alt" />Login
          </router-link>
        </li>
      </div>

      <div v-if="currentUser" class="navbar-nav ml-auto">
        <li class="nav-item">
          <router-link to="/profile" class="nav-link">
            <font-awesome-icon icon="user" />
            {{ currentUser.username }}
          </router-link>
        </li>
        <li class="nav-item">
          <a class="nav-link" href @click.prevent="logOut">
            <font-awesome-icon icon="sign-out-alt" />LogOut
          </a>
        </li>
      </div>
    </nav> -->

    <div class="container-fluid mt-5" >
    <SideMenu class="d-xl-none"/>
      <router-view />
      
    </div>
    
    <Footer/>
  </div>
</template>
<style>
.bg-menu{
    background-color: #144163 !important;
    color:#fff !important;
}
body{
  background:#ebebeb !important;
}
@import url('assets/style.css');

</style>
<script>
import Header from '../src/components/Header.vue';
import Banner from '../src/components/Banner.vue';
import Footer from '../src/components/Footer.vue';
 import SideMenu from '../src/components/SideMenu.vue';

export default {
//   data() {
// this.$route.path === '/login' ? this.showHeader = false : this.showHeader = true
// },
  components:{
    Footer,
    Header,
     SideMenu,
    Banner
  },

  computed: {
  
    currentUser() {
      return this.$store.state.auth.user;
    },

    // showAdminBoard() {
    //   if (this.currentUser && this.currentUser.Roles) {
    //     return this.currentUser.Roles.includes('Employee');
    //   }

    //   return false;
    // },
    // showModeratorBoard() {
    //   if (this.currentUser && this.currentUser.Roles) {
    //     return this.currentUser.Roles =='Admission';
    //   }

    //   return false;
    // }
  },
  methods: {
   
  OnRouteChange() {
     this.showHeader = true;
    if (route.name == "login" || route.name == "signup") {
      this.showHeader = false;
    } else {
      this.showHeader = true;
    }
  },
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    },
  
  }
  
};



</script>
